import { millisecondsToseconds } from "./utils";

// const FLOAT_32 = 32

/**
 * This class defines the audio buffer and its controls
 * @param duration the duration of the signal (ms) contained in the buffer
 * @param sr sampling frequency
 */
export class CustomAudioBuffer {
  private buffer: number[];
  private iterator: number;
  private bufferLength: number;
  private sampleRate: number;

  constructor(duration: number, sr: number) {
    this.buffer = [];
    this.bufferLength = Math.floor(millisecondsToseconds(duration) * sr)
    this.sampleRate = sr;
    this.clear();
  }

  private get reverseIterator() {
    return this.bufferLength - this.iterator;
  }

  public setDuration(duration: number) {
    this.buffer = [];
    this.bufferLength = Math.floor(millisecondsToseconds(duration) * this.sampleRate)
    this.clear();
  }

  /**
     * Fill the buffer with zero values and reset the iterator
     */
  public clear() {
    this.buffer.length = 0;
  }

  /**
     * 
     * @param x input data
     */
  public update(x: number[], _callback: (data: Float32Array, sr: number) => void) { // Assuming x length is always smaller than twice the buffer length
    /*
        let _delta = Math.min(x.length, this.reverseIterator);
        this.iterator += _delta;
        this.buffer.push.apply(this.buffer, x.slice(0, _delta)); 
        if (this.iterator + 1 >= this.bufferLength) {
            const _dataToSend = this.buffer.splice(0, this.buffer.length);
            console.log("Send data of length : ", _dataToSend.length);
            // Pass the data to the function as Float32Array
            _callback(new Float32Array(_dataToSend), this.sampleRate);
            if (_delta < x.length) {
                this.buffer.push.apply(this.buffer, x.slice(_delta, x.length-_delta));
                this.iterator += x.length-_delta;
            }
        } */

    this.buffer.push.apply(this.buffer, x);
    if (this.buffer.length >= this.bufferLength) {
      const _audioBuffer = this.buffer.splice(0, this.bufferLength);
      _callback(new Float32Array(_audioBuffer), this.sampleRate);
    }
  }

    
}